<template>
  <base-page-component>
    <div>
      <span class="text-danger" v-for="item in validateErrors.items" v-bind:key="item.id">
        {{ `#${item.id}: ${item.msg}`}}
        <br />
      </span>
    </div>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Enterprise Management : {{ partnerName }}</strong> <button class="btn btn-success mt-1" style="float:right;"><i title="Create a new enterprise" class="fa fa-plus-square"></i> <strong class="text-white" @click="addNewEnterprise">Create New</strong></button>
        </div>
        <b-row class="my-1">
          <b-col md="6"></b-col>
          <b-col md="3" class="pr-1">
            <b-form-select v-model="selectedPartnerId" id="selectedPartnerId" value-field="partner_id" text-field="name" :options="partners"></b-form-select>
          </b-col>
          <b-col md="3">
            <b-form-input placeholder="Search" v-model="enterpriseSearchFilter" @keydown.native="keyCheck" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-card>
              <!-- Main table element -->
              <b-table ref="tblEnterprises" id="tblEnterprises" custom-row-key="Name" :items="enterpriseList" hover striped bordered small :fields="fields" show-empty :empty-text="emptytext" @row-clicked="rowClickHandler">
                <template slot="Accounts.AccountName" slot-scope="row">
                  <ul v-if="row.item.Name.toLowerCase().indexOf(enterpriseSearchFilterLower) > -1">
                    <li v-for="a in row.item.Accounts">
                      {{ a.AccountName }}
                    </li>
                  </ul>
                  <ul v-else>
                    <li v-for="a in row.item.Accounts.filter(x => x.AccountName.toLowerCase().indexOf(enterpriseSearchFilterLower) > -1 || x.AccountNumber.toLowerCase().indexOf(enterpriseSearchFilterLower) > -1)">
                      {{ a.AccountName }}
                    </li>
                  </ul>
                </template>
                <template slot="Accounts.AccountNumber" slot-scope="row">
                  <ul v-if="row.item.Name.toLowerCase().indexOf(enterpriseSearchFilterLower) > -1">
                    <li v-for="a in row.item.Accounts">
                      {{ a.AccountNumber }}
                    </li>
                  </ul>
                  <ul v-else>
                    <li v-for="a in row.item.Accounts.filter(x => x.AccountName.toLowerCase().indexOf(enterpriseSearchFilterLower) > -1 || x.AccountNumber.toLowerCase().indexOf(enterpriseSearchFilterLower) > -1)">
                      {{ a.AccountNumber }}
                    </li>
                  </ul>
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </base-page-component>
</template>

<script>
  import axios from 'axios'
  import { basePageMixin } from '@/mixins/basePageMixin'
  export default {
    mixins: [basePageMixin],
    data() {
      return {
        partners: [],
        selectedPartnerId: null,
        items: undefined,
        allEnterprises: [],
        itemsAdded: [],
        itemsDeleted: [],
        enterpriseSearchFilter: [],
        fields: [
          { key: 'Name', label: 'Enterprise Name', sortable: true },
          { key: 'Accounts.AccountName', label: 'Account Name', sortable: false },
          { key: 'Accounts.AccountNumber', label: 'Account Number', sortable: false }
        ],
        emptytext: 'No enterprise accounts exist.',
        textEnterpriseInput: ''
      }
    },
    async created() {
      //Get partners and accounts list
      try {
        this.toggleloader(true)
        
        //Get all enterprises
        var response = await axios.get('/api/enterprise/loadenterprises')
        this.allEnterprises = response.data

        //Get all partners list
        response = await axios.get('/api/PartnersAPI/GetPartnersGuid')
        this.partners = [{ 'partner_id': null, 'name': 'Select a Partner' }, ...response.data.PARTNERS]

        //used to pass a message to this page when calling the page
        if (this.$route.params.msg) {
          this.showNotification(this.$route.params.msg)
        }

        //if you want to preset to start at a dropdown selection
        if (this.$route.params.partnerId) {
          this.selectedPartnerId = this.$route.params.partnerId
        }
      }
      catch (error) {
        this.handleError(error)
        this.errMsg = 'There was an error getting data : ' + error
      }
      finally {
        this.toggleloader(false)
      }
    },
    computed: {
      partnerName() {
        var selectedPartner = this.partners.find(p => p.partner_id === this.selectedPartnerId)

        if (selectedPartner) {
          return selectedPartner.name
        }

        return "Select a partner"
      },
      enterpriseSearchFilterLower() {
        //need to put this in a condition because applying .toLowerCase() to empty string will throw an error
        return this.enterpriseSearchFilter.length > 0 ? this.enterpriseSearchFilter.toLowerCase() : ''
      },
      enterpriseList() {
        if (!this.selectedPartnerId)
          return []
        
        //filtering results by selected partner from dropdownlist and filter by search box value on enterprise name, account name and account number in the enterprise
        return this.allEnterprises.filter(f => f.PartnerId === this.selectedPartnerId &&
          (f.Name.toLowerCase().indexOf(this.enterpriseSearchFilterLower) > -1 ||
            f.Accounts.filter(x => x.AccountName.toLowerCase().indexOf(this.enterpriseSearchFilterLower) > -1 ||
              x.AccountNumber.toLowerCase().indexOf(this.enterpriseSearchFilterLower) > -1).length > 0)
        )
      }
    },
    methods: {
      rowClickHandler(record) {
        this.$router.push({
          name: 'EnterpriseDetails',
          params: { enterpriseId: record.EnterpriseId, partnerId: this.selectedPartnerId, partnerName: this.partnerName }
        })
      },
      addNewEnterprise() {
        if (!this.selectedPartnerId) {
          this.showError('Please select a partner first', false)
          return
        }

        this.$router.push({
          name: 'EnterpriseDetails',
          params: { partnerId: this.selectedPartnerId, partnerName: this.partnerName }
        })
      },
      keyCheck(event) {
        //prevent search to start with space
        if (event.which === 32 && this.enterpriseSearchFilter.length == 0) {
          event.preventDefault()
        }

      }
    }
  }
</script>


<style>
  ul {
    padding-left: 0px;
    list-style: none;
  }

  #tblEnterprises th
  {
      width: 33%
  }
</style>



// WEBPACK FOOTER //
// src/views/Enterprise.vue